module.exports = __webpack_public_path__ + "img/datas-background.997ab731.png";